<template>
  <div class="logo-component" :class="{ 'is-large': large }">
    <router-link :to="to">
      <!-- 替换 SVG 为图片 -->
      <img class="brand-logo" src="../assets/logo.png" />
      <span v-if="showText" class="brand-name">{{ text }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    to: {
      type: String,
      default: '/'
    },
    text: {
      type: String,
      default: '和祥泰数码科技有限公司'
    },
    showText: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
.logo-component {
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: var(--secondary-color);
  }

  .brand-logo {
    width: 40px;
    height: 40px;
    transition: transform 0.3s ease;
    object-fit: contain;

    &:hover {
      transform: rotate(5deg) scale(1.05);
    }
  }

  .brand-name {
    margin-left: 10px;
    font-size: 18px;
    font-weight: 600;
  }

  &.is-large {
    .brand-logo {
      width: 60px;
      height: 60px;
    }

    .brand-name {
      font-size: 24px;
    }
  }
}

@media (max-width: 768px) {
  .logo-component {
    .brand-logo {
      width: 35px;
      height: 35px;
    }

    .brand-name {
      font-size: 16px;
    }

    &.is-large {
      .brand-logo {
        width: 50px;
        height: 50px;
      }

      .brand-name {
        font-size: 20px;
      }
    }
  }
}
</style>
